/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root',
})
export class UserServiceFormdata extends UserService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation userPost
   */
  static readonly UserPostPath = '/api/User/Post';

  /**
   * Felhasználó létrehozása vagy módosítása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  userPostFormData(formData: FormData): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, UserService.UserPostPath, 'post');
    if (formData) {


      rb.body(formData, 'multipart/form-data');
    }
    const url = this.rootUrl + UserService.UserPostPath;
    return this.http.post(url, formData).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

    userPostFormData2(formData: FormData): Observable<number> {

    const rb = new RequestBuilder(this.rootUrl, UserService.UserPostPath, 'post');
    if (formData) {
      rb.body(formData, 'multipart/form-data');
    }
    const url = this.rootUrl + UserService.UserPostPath;
    return this.http.post(url, formData).pipe(
      map((r: any) => {
        return r.id as number;
      })
    );
  }

}
